export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6494.b4c670d1.jpg";